import script from "./WLoaderComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./WLoaderComplete.vue?vue&type=script&setup=true&lang=js"

import "./WLoaderComplete.vue?vue&type=style&index=0&id=560b8f1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560b8f1e"]])

export default __exports__